import {FilterSelectFieldConfig} from "./filter-select-field.config";
import {buildAsyncValidators, buildDefaultValidators} from "../../dynamic-field/default-control-builder";
import {ValidatorFn} from "@angular/forms";
import {ControlBuilder} from "../../dynamic-field/control-builder.type";

export const FilterSelectControlBuilder: ControlBuilder = (fieldConfig: FilterSelectFieldConfig, formBuilder) => {

    const {disabled, value} = fieldConfig;

    const validators = buildDefaultValidators(fieldConfig);

    const asyncValidators = buildAsyncValidators(fieldConfig);

    return formBuilder.control(
        {
            disabled,
            value: value ?? null
        },
        validators,
        asyncValidators
    );
};
export const FilterSelectFieldValidators: (fieldConfig: FilterSelectFieldConfig) => ValidatorFn[] =
    (config): ValidatorFn[] => {
        const validators = buildDefaultValidators(config);

        return validators;
    };

